import Layout from "../../components/Layout";
import AdminCollectionTable, { formatMoney } from "../../components/AdminCollectionTable";

const pct = (v) => (v === null || v === undefined || v === "" ? "—" : `${(Number(v) * 100).toFixed(2)}%`);
const yn = (v) => (v === true ? "Yes" : v === false ? "No" : "—");

const COLUMNS = [
  { key: "supplier_name",   label: "Supplier",         path: "SupplierName",         sortable: true, sortPath: "SupplierName" },
  { key: "account_no",      label: "Account #",        path: "AccountNumber",        sortable: true, sortPath: "AccountNumber" },
  { key: "contact_name",    label: "Primary contact",  path: "ContactName1" },
  { key: "contact_email",   label: "Primary email",    path: "ContactName1Email" },
  { key: "contact_tel",     label: "Primary phone",    path: "ContactName1TelNo" },
  { key: "city",            label: "City",             path: "City",                 sortable: true, sortPath: "City" },
  { key: "postcode",        label: "Postcode",         path: "Postcode",             sortable: true, sortPath: "Postcode" },
  { key: "enabled",         label: "Enabled",          path: "Enabled",              sortable: true, sortPath: "Enabled", formatter: yn },
  { key: "rebate",          label: "Rebate %",         path: "PercentRebate",        sortable: true, sortPath: "PercentRebate", formatter: pct },
  { key: "discount",        label: "Discount %",       path: "PercentDiscount",      sortable: true, sortPath: "PercentDiscount", formatter: pct },
];

export default function SupplierManagement() {
  return (
    <Layout>
      <AdminCollectionTable
        collectionName="suppliers"
        title="Suppliers"
        subtitle="Talmia I Suppliers"
        columns={COLUMNS}
        alphaField="SupplierName"
      />
    </Layout>
  );
}
